<template>
  <section class="bg-white shadow p-2 my-4">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h2 class="mb-0">Benutzer</h2>

      <div class="d-flex gap-2">
        <EditUserModal :index="0" :buttonStyle="0" :realm="unternehmen.realm" @saved-benutzer="unternehmenStore.getUnternehmenUsers(unternehmen.realm)" />
        <div
          v-if="
            unternehmen.archivApiUrl != undefined && unternehmen.archivApiUrl != '' && unternehmen.archivApiKey != undefined && unternehmen.archivApiKey != ''
          "
        >
          <ImportArchivUserModal :unternehmen="unternehmen" @importedBenutzer="unternehmenStore.getUnternehmenUsers(unternehmen.realm)" />
        </div>
      </div>
    </div>

    <LoadingSpinner v-if="loading" />
    <div v-else-if="errorMsg" class="alert alert-danger my-3">{{ errorMsg }}</div>
    <div v-else>
      <div v-if="sortedUsers.length == 0" class="alert alert-info my-3">Keine Benutzer gefunden.</div>

      <div v-else>
        <UserRow v-for="user in sortedUsers" :key="user.id" :user="user" :realm="unternehmen.realm" />
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, onMounted, PropType } from 'vue';
  import { useUnternehmenStore } from '@/stores/unternehmenStore';
  import { useCommonStore } from '@/stores/commonStore';

  import { User } from '@/models/BenutzerModels';
  import { Unternehmen } from '@/models/UnternehmenModels';

  import UserRow from '@/components/Benutzer/UserRow.vue';
  import EditUserModal from '@/components/Benutzer/EditUserModal.vue';
  import ImportArchivUserModal from '@/components/Unternehmen/users/ImportArchivUserModal.vue';
  import LoadingSpinner from '@/components/LoadingSpinner.vue';
  //#endregion

  const { unternehmen } = defineProps({
    unternehmen: {
      type: Object as PropType<Unternehmen>,
      required: true,
    },
  });

  const unternehmenStore = useUnternehmenStore();
  const commonStore = useCommonStore();

  const loading = computed(() => commonStore.status.getUnternehmenUsersLoading);
  const errorMsg = computed(() => commonStore.status.unternehmenUserErrorMsg);

  const sortedUsers = computed(() =>
    unternehmenStore.users.slice().sort((a: User, b: User) => {
      const lastNameComparison = a.lastName.localeCompare(b.lastName);

      if (lastNameComparison == 0) {
        return a.firstName.localeCompare(b.firstName);
      }

      return lastNameComparison;
    })
  );

  onMounted(async () => {
    await unternehmenStore.getUnternehmenUsers(unternehmen.realm);
  });
</script>
